import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import BookedCar from "../../../components/comment/bookedcar/bookedCar";

import CarFeature from "../../../components/comment/carfeature/carFeature";
import BookNowStatus from "../booknowstatus/bookNowStatus";
import marutibreeza from "../../../assets/images/maruti-breeza.png";
import hyundai from "../../../assets/images/hyundai.png";
import marutiSwift from "../../../assets/images/maruti-swift.png";
import marutiCiaz from "../../../assets/images/maruti-ciaz.png";

const carRentalStatus = () => {
  return (
    <section className="car-rental">
      <div className="car-book-wrap">
        <div className="car-rental-content">
          <Row>
            <Col md={3}>
              {" "}
              <div className="car-image">
                <BookedCar img={marutibreeza} />
              </div>
            </Col>
            <Col md={6}>
              <div className="feature">
                <CarFeature cartitle="Maruti Brezza" />{" "}
              </div>
            </Col>
            <Col md={3}>
              <div className="book-now">
                <BookNowStatus price="₹ 3,220" />
              </div>
            </Col>
          </Row>
        </div>
      </div>

      <div className="car-book-wrap">
        <div className="car-rental-content">
          <Row>
            <Col md={3}>
              {" "}
              <div className="car-image">
                <BookedCar img={hyundai} />
              </div>
            </Col>
            <Col md={6}>
              <div className="feature">
                <CarFeature cartitle="Hyundai Santro MT" />{" "}
              </div>
            </Col>
            <Col md={3}>
              <div className="book-now">
                <BookNowStatus price="₹ 2,260" />
              </div>
            </Col>
          </Row>
        </div>
      </div>

      <div className="car-book-wrap">
        <div className="car-rental-content">
          <Row>
            <Col md={3}>
              {" "}
              <div className="car-image">
                <BookedCar img={marutiSwift} />
              </div>
            </Col>
            <Col md={6}>
              <div className="feature">
                <CarFeature cartitle="Maruti Swift AT" />{" "}
              </div>
            </Col>
            <Col md={3}>
              <div className="book-now">
                <BookNowStatus price="₹ 3,480" />
              </div>
            </Col>
          </Row>
        </div>
      </div>

      <div className="car-book-wrap">
        <div className="car-rental-content">
          <Row>
            <Col md={3}>
              {" "}
              <div className="car-image">
                <BookedCar img={marutiCiaz} />
              </div>
            </Col>
            <Col md={6}>
              <div className="feature">
                <CarFeature cartitle="Maruti Ciaz AT" />{" "}
              </div>
            </Col>
            <Col md={3}>
              <div className="book-now">
                <BookNowStatus price="₹ 4,140" />
              </div>
            </Col>
          </Row>
        </div>
      </div>

      <div className="car-book-wrap">
        <div className="car-rental-content">
          <Row>
            <Col md={3}>
              {" "}
              <div className="car-image">
                <BookedCar img={marutiSwift} />
              </div>
            </Col>
            <Col md={6}>
              <div className="feature">
                <CarFeature cartitle="Maruti Swift AT" />{" "}
              </div>
            </Col>
            <Col md={3}>
              <div className="book-now">
                <BookNowStatus price="₹ 5,117" />
              </div>
            </Col>
          </Row>
        </div>
      </div>

      <div className="car-book-wrap">
        <div className="car-rental-content">
          <Row>
            <Col md={3}>
              {" "}
              <div className="car-image">
                <BookedCar img={marutiSwift} />
              </div>
            </Col>
            <Col md={6}>
              <div className="feature">
                <CarFeature cartitle="Maruti Swift Dzire" />{" "}
              </div>
            </Col>
            <Col md={3}>
              <div className="book-now">
                <BookNowStatus price="₹ 3,698" />
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </section>
  );
};

export default carRentalStatus;
